import { motion } from "framer-motion";
import { useContent } from "@/content/ContentContext";

const ease = [0.22, 1, 0.36, 1];

export default function Manifesto() {
  const content = useContent();
  const m = content.manifesto;
  return (
    <section
      id="legacy"
      data-testid="manifesto-section"
      className="relative mx-auto max-w-[1440px] px-6 py-28 lg:px-12 lg:py-40"
    >
      <div className="grid gap-16 lg:grid-cols-12 lg:gap-20">
        <motion.div
          initial={{ opacity: 0, y: 48 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease }}
          className="lg:col-span-5"
        >
          <div className="group relative overflow-hidden border border-line" data-testid="manifesto-image-frame">
            <img
              src={m.image}
              alt="Farmer standing in a lush green field"
              className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/20 transition-colors duration-500 group-hover:bg-black/0" />
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.2em] text-sage">
            {m.caption}
          </p>
        </motion.div>

        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease }}
            className="text-xs uppercase tracking-[0.3em] text-harvest"
          >
            {m.overline}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.1, ease }}
            data-testid="manifesto-heading"
            className="mt-6 font-display text-4xl font-light leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl"
          >
            {m.headingA} <br />
            <span className="italic text-harvest">{m.headingAccent}</span> {m.headingB}
          </motion.h2>

          <div className="mt-16 space-y-14">
            {m.chapters.map((c, i) => (
              <motion.div
                key={c.num}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, delay: i * 0.08, ease }}
                data-testid={`manifesto-chapter-${c.num}`}
                className="relative border-t border-line pt-8"
              >
                <span
                  aria-hidden="true"
                  className="pointer-events-none absolute -top-6 right-0 font-display text-7xl font-light italic text-harvest/15 sm:text-8xl"
                >
                  {c.num}
                </span>
                <h3 className="font-display text-2xl font-medium tracking-tight text-cream sm:text-3xl">
                  {c.title}
                </h3>
                <p className="mt-4 max-w-lg text-sm leading-relaxed text-sage sm:text-base">
                  {c.text}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
